var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8 8.8C26.8 8.35817 26.4418 8 26 8C25.5582 8 25.2 8.35817 25.2 8.8V11.2H22.8C22.3582 11.2 22 11.5582 22 12C22 12.4418 22.3582 12.8 22.8 12.8H25.2V15.2C25.2 15.6418 25.5582 16 26 16C26.4418 16 26.8 15.6418 26.8 15.2V12.8H29.2C29.6418 12.8 30 12.4418 30 12C30 11.5582 29.6418 11.2 29.2 11.2H26.8V8.8ZM12.9245 22.4286C11.8403 23.983 10.0389 25 7.99999 25C4.68629 25 2 22.3137 2 19C2 15.6863 4.68629 13 7.99999 13C11.3137 13 14 15.6863 14 19C14 19.291 13.9793 19.5772 13.9392 19.8571H24.2857V18.5714L22.6786 17.2857H13.7516C13.5673 16.6665 13.2857 16.0891 12.9246 15.5714H23.2799L26 17.7475V21.5714L25.1428 22.4286H23.4285L22.5714 21.5714H20.8571L20 22.4286H17.4285L16.5714 21.5714H14.8571L14 22.4286H12.9245ZM12.2857 19C12.2857 21.3669 10.3669 23.2857 7.99999 23.2857C5.63306 23.2857 3.71428 21.3669 3.71428 19C3.71428 16.6331 5.63306 14.7143 7.99999 14.7143C10.3669 14.7143 12.2857 16.6331 12.2857 19ZM6.28571 20.7143C7.23248 20.7143 7.99999 19.9468 7.99999 19C7.99999 18.0532 7.23248 17.2857 6.28571 17.2857C5.33893 17.2857 4.57142 18.0532 4.57142 19C4.57142 19.9468 5.33893 20.7143 6.28571 20.7143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateToken);
export default __webpack_public_path__ + "static/media/create-token.4f9a0cdb722b77277e981db4dad2ed0b.svg";
export { ForwardRef as ReactComponent };